<div class="dialog" role="document" aria-labelledby="forward-dialog-title">
  <div class="dialog-header">
    <span class="dialog-title" id="forward-dialog-title">{{ title }}</span>
    <button type="button" class="close-btn" [disabled]="isLoading" (click)="close()" aria-label="Close">×</button>
  </div>

  @if(data.cancelMode){
  <p class="dialog-note">
    The admin reviews it in the "Confirmed to cancel" queue and completes the cancellation.
    The booking stays confirmed until then.
  </p>
  }

  <form [formGroup]="form" class="dialog-form" novalidate (ngSubmit)="submit()">
    @if(!data.cancelMode){
    <div class="field">
      <span class="field-label">Forward reason <span aria-hidden="true">*</span></span>
      <select class="text-box-active" formControlName="forwardReason">
        <option value="">Pick a reason</option>
        @for(r of forwardReasons; track r){ <option [value]="r">{{ r }}</option> }
      </select>
    </div>
    }
    <div class="field">
      <span class="field-label">Remark{{ data.cancelMode ? ' (optional, for the admin)' : '' }}</span>
      <input type="text" class="text-box-active" formControlName="forwardRemark" />
    </div>

    <div class="dialog-actions">
      <button type="button" class="ac-secondary-btn" [disabled]="isLoading" (click)="close()">Cancel</button>
      <button type="submit" class="ac-primary-btn" [disabled]="isLoading || form.invalid">{{ submitLabel }}</button>
    </div>
  </form>
</div>

<app-loader [isLoading]="isLoading"></app-loader>
